export default __webpack_public_path__ + "static/media/teligram.10e43168.svg";